const isProduction = process.env.REACT_APP_STAGE === 'PROD'
const userPoolId = process.env.REACT_APP_USER_POOL_ID
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID
const userPoolWebClientId = process.env.REACT_APP_WEB_CLIENT_ID
const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN
const region = process.env.REACT_APP_REGION
const consoleApiUrl = process.env.REACT_APP_CONSOLE_API_URL

export {
    isProduction,
    userPoolId,
    identityPoolId,
    userPoolWebClientId,
    cognitoDomain,
    region,
    consoleApiUrl
}